import { Component, computed, inject, Input } from '@angular/core'
import { NavItem } from '../../sidebar/nav-item.interface'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { RouterLink, RouterModule } from '@angular/router'
import { NgbDropdownModule, NgbModal, NgbOffcanvas, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { StaffMapModalComponent } from '../../staff/staff-map-modal/staff-map-modal.component'
import { PendingAppointmentsPulloutComponent } from '../../appointments/pending-appointments-pullout/pending-appointments-pullout.component'
import { RecentCustomersPulloutComponent } from '../../customer/recent-customers-pullout/recent-customers-pullout.component'
import { AppStore } from 'src/app/core/app.store'
import { StaffPulloutComponent } from '../../staff/staff-pullout/staff-pullout.component'
import { OnboardingService } from 'src/app/core/services/onboarding/onboarding.service'
import { PercentPipe } from '@angular/common'
import { NgxPermissionsModule } from 'ngx-permissions'

@Component({
    selector: 'sf-sidebar-starter-nav',
    imports: [FontAwesomeModule, NgxPermissionsModule, NgbTooltipModule, NgbDropdownModule, RouterModule, PercentPipe],
    templateUrl: './sidebar-starter-nav.component.html',
    styleUrl: './sidebar-starter-nav.component.scss',
    host: {
        class: 'sidebar-starter-nav',
    },
})
export class SidebarStarterNavComponent {
    #modalService = inject(NgbModal)
    #offCanvas = inject(NgbOffcanvas)
    #appStore = inject(AppStore)
    #onboardingService = inject(OnboardingService)

    recentlyViewedCustomerCount = this.#appStore.recentlyViewedCustomerCount
    staff = this.#appStore.staff
    onBoardingProgress = computed(() => this.#onboardingService.getProgress())

    openStaffMapModal(): void {
        this.#modalService.open(StaffMapModalComponent, { size: 'xl', fullscreen: 'lg' })
    }

    openPendingAppointmentsOffCanvas(): void {
        this.#offCanvas.open(PendingAppointmentsPulloutComponent, { position: 'end' })
    }

    openRecentCustomersOffCanvas(): void {
        this.#offCanvas.open(RecentCustomersPulloutComponent, { position: 'end' })
    }

    openStaffOffCanvas(): void {
        this.#offCanvas.open(StaffPulloutComponent, { position: 'end' })
    }

    openOnboardingChecklist(): void {
        this.#onboardingService.showOnboarding()
    }
}
